import "../styles/booking-detail.css";
import React, { useState, useEffect, useRef } from "react";
import BookingController from "../services/booking-controller";
import { PrimeIcons } from "primereact/api";
import { Dialog } from "primereact/dialog";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";
import { getToken } from "../utility";

export default function BookingDetail(props) {
	const bookingController = new BookingController();
	const [isLoading, setIsLoading] = useState(true);
	const [residence, setResidence] = useState({});
	const [isFullSummary, setIsFullSummary] = useState(false);
	const [isVisibleNotes, setIsVisibleNotes] = useState(false);
	const [isVisibleFacilities, setIsVisibleFacilities] = useState(false);
	const [isVisibleDuration, setIsVisibleDuration] = useState(false);
	const [startDate, setStartDate] = useState(null);
	const [durations, setCurrentDurations] = useState([]);
	const [currentDuration, setCurrentDuration] = useState(0);
	const [currentResidenceRoomTypeId, setCurrentResidenceRoomTypeId] =
		useState("");
	const datePickerRef = useRef();

	const weekDays = [
		"شنبه",
		"یکشنبه",
		"دوشنبه",
		"سه شنبه",
		"چهارشنبه",
		"پنجشنبه",
		"جمعه",
	];

	Number.prototype.toTimeFormat = function () {
		if (!this) return "";
		return (
			Math.floor(this / 60)
				.toString()
				.padStart(2, "0") +
			":" +
			(this % 60).toString().padStart(2, "0")
		);
	};

	const showDuration = function (objStartDate) {
		if (!startDate && !objStartDate) openDatePicker();
		else {
			if (!objStartDate) objStartDate = startDate;
			window.ss = objStartDate;
			let objDate = objStartDate.toDate();

			let tempArray = [];
			for (let i = 1; i < 4; i++)
				tempArray.push({
					total: i,
					date: new DateObject({
						date: addDays(objDate, i),
						calendar: persian,
						locale: persian_fa,
					})
						.setCalendar(persian)
						.format("D MMMM YYYY"),
				});
			setCurrentDurations(tempArray);
			setIsVisibleDuration(true);
		}
	};

	//> addDays
	const addDays = function (date, days) {
		var result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	};

	const openDatePicker = function (residenceRoomTypeId) {
		setCurrentResidenceRoomTypeId(residenceRoomTypeId);
		datePickerRef.current.openCalendar();
	};

	const confirmStartDate = function (value) {
		try {
			setStartDate(value);
			showDuration(value);
		} catch (error) {
			alert(error.toString());
		}
	};

	const confirmDuration = async function (value) {
		try {
			setCurrentDuration(value);
			setIsVisibleDuration(false);
			//>
			let remainResults = await bookingController.getRemainResidenceRoomTypes(
				residence.residenceId,
				startDate.toDate(),
				value
			);
			if (remainResults.isSuccess === false) throw remainResults.message;

			residence.roomTypes.forEach((item) => {
				item.total = 0;
				let objRemain = remainResults.value.find(
					(x) => x.residenceRoomTypeId === item.residenceRoomTypeId
				);
				if (objRemain) {
					item.total = objRemain.totalRemain;
				}
			});
			setResidence({ ...residence });
			//<
			if (currentResidenceRoomTypeId) {
				confirm(currentResidenceRoomTypeId, value);
			}
		} catch (error) {
			alert(error.toString());
		}
	};

	const confirm = async function (residenceRoomTypeId, duration) {
		try {
			if (!duration) duration = currentDuration;
			//>
			let remainResults = await bookingController.getRemainResidenceRoomTypes(
				residence.residenceId,
				startDate.toDate(),
				duration
			);
			if (remainResults.isSuccess === false) throw remainResults.message;
			let objRemain = remainResults.value.find(
				(item) => item.residenceRoomTypeId === residenceRoomTypeId
			);
			if (!objRemain || objRemain.totalRemain <= 0)
				throw "ظرفیت خالی برای رزرو این اتاق اقامتگاه برای تاریخ انتخاب شده وجود ندارد";
			//<
			let params = {
				id: residenceRoomTypeId,
				date: startDate.toDate().getTime(),
				total: duration,
			};
			window.location =
				"/#/booking-register/?q=" + btoa(JSON.stringify(params));
		} catch (error) {
			alert(error.toString());
		}
	};

	const getData = async function () {
		try {
			if (residence.residenceId) return;
			let residenceId = "";
			if (window.location.href.indexOf("?") > 0) {
				let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
				residenceId = urlParams.get("residenceId");
			}
			// getResidence
			const residenceResult = await bookingController.getResidence(residenceId);
			if (residenceResult.isSuccess === false) throw residenceResult.message;
			//>
			let remainResults = await bookingController.getRemainResidenceRoomTypes(
				residenceId,
				new Date(),
				3
			);
			if (remainResults.isSuccess === false) throw remainResults.message;
			residenceResult.value.roomTypes.forEach((item) => {
				item.total = 0;
				let objRemain = remainResults.value.find(
					(x) => x.residenceRoomTypeId === item.residenceRoomTypeId
				);
				if (objRemain) {
					item.total = objRemain.totalRemain;
				}
			});
			//<

			setResidence(residenceResult.value);
			setIsLoading(false);
		} catch (error) {
			alert(error.toString());
		}
	};

	useEffect(() => {
		getData();
	}, [residence]);

	if (!getToken()) {
		window.location = "/#/login?returnUrl=/booking-home";
		return <></>;
	}
	return isLoading ? (
		<span>Loading</span>
	) : (
		<article className="bkd-detail">
			<div className="bkd-top">
				<a href="/#/booking-home">رزرو اقامتگاه</a>
				<i className={PrimeIcons.ANGLE_LEFT}></i>
				<a href="/#/booking-home">اقامتگاه های {residence.cityName}</a>
				<i className={PrimeIcons.ANGLE_LEFT}></i>
				<a href="/#/booking-home">{residence.name}</a>
			</div>

			<div className="bkd-header">
				<div className="bkd-info">
					{/* <span className="bkd-rate">
						{Array(residence.rate)
							.fill(1)
							.map((rateItem, index) => (
								<i key={index} className={PrimeIcons.STAR_FILL}></i>
							))}
					</span> */}
					<h2>{residence.name}</h2>
					<div className="bkd-address">
						<p>{residence.address}</p>
						{/* <a>مشاهده روی نقشه</a> */}
					</div>
				</div>

				<div className="bkd-actions">
					<a className="bkd-icon">
						<i className={PrimeIcons.SHARE_ALT}></i>
					</a>
					<a className="bkd-icon">
						<i className={PrimeIcons.HEART}></i>
					</a>
					<a
						className="bkd-rooms-select"
						onClick={() =>
							document.querySelector(".bkd-rooms").scrollIntoView()
						}
					>
						لیست اتاق های اقامتگاه
					</a>
				</div>
			</div>

			<div className="bkd-images">
				<ul>
					{residence.images
						.filter((item) => residence.images.indexOf(item) < 5)
						.map((item, index) => (
							<li key={index}>
								<img src={item} />
							</li>
						))}
				</ul>
				<a className="bkd-link-more">
					مشاهده همه <i className={PrimeIcons.EXTERNAL_LINK}></i>
				</a>
			</div>

			<div className="bkd-about">
				<div className="bkd-about-notes">
					<h2>درباره {residence.name}</h2>
					<ul>
						<li>
							<label>
								<i className={PrimeIcons.SIGN_IN}></i>
								ساعت ورود
							</label>
							<strong>{residence.startTime.toTimeFormat()}</strong>
						</li>
						<li>
							<label>
								<i className={PrimeIcons.SIGN_OUT}></i>
								ساعت خروج
							</label>
							<strong>{residence.endTime.toTimeFormat()}</strong>
						</li>
						<li>
							<label>
								<i className={PrimeIcons.FILE}></i>
								تعداد اتاق
							</label>
							<strong>{residence.totalRooms}</strong>
						</li>
						<li>
							<label>
								<i className={PrimeIcons.USERS}></i>
								ظرفیت اقامتگاه
							</label>
							<strong>{residence.totalCapacity}</strong>
						</li>
						<li>
							<label>
								<i className={PrimeIcons.USERS}></i>
								حداکثر تعداد نفرات اضافه
							</label>
							<strong>{residence.totalExtraCapacity}</strong>
						</li>
					</ul>
					<p className={isFullSummary === true ? "bkd-full" : ""}>
						{residence.summary}
					</p>
					<a
						className="bkd-link-more"
						onClick={() => setIsFullSummary(!isFullSummary)}
					>
						{isFullSummary === false && (
							<>
								مشاهده بیشتر
								<i className={PrimeIcons.ANGLE_DOWN}></i>
							</>
						)}
						{isFullSummary === true && (
							<>
								مشاهده کمتر
								<i className={PrimeIcons.ANGLE_UP}></i>
							</>
						)}
					</a>
				</div>
				<div className="bkd-facilities">
					<h2>امکانات عمومی</h2>
					<ul>
						{residence.publicFacilities
							.filter((item) => residence.publicFacilities.indexOf(item) < 6)
							.map((item, index) => (
								<li key={index}>
									<i className={PrimeIcons.CHECK}></i>
									{item.name}
								</li>
							))}
					</ul>
					<a
						className="bkd-link-more"
						onClick={() => setIsVisibleFacilities(true)}
					>
						<i className={PrimeIcons.EXTERNAL_LINK}></i>
						مشاهده همه
					</a>
				</div>
				<div className="bkd-facilities">
					<h2>امکانات اتاق ها</h2>
					<ul>
						{residence.roomFacilities
							.filter((item) => residence.roomFacilities.indexOf(item) < 6)
							.map((item, index) => (
								<li key={index}>
									<i className={PrimeIcons.CHECK}></i>
									{item.name}
								</li>
							))}
					</ul>
					<a
						className="bkd-link-more"
						onClick={() => setIsVisibleFacilities(true)}
					>
						<i className={PrimeIcons.EXTERNAL_LINK}></i>
						مشاهده همه
					</a>
				</div>
			</div>

			<Dialog
				header="امکانات بیشتر"
				visible={isVisibleFacilities}
				style={{ width: "85vw" }}
				onHide={() => {
					if (!isVisibleFacilities) return;
					setIsVisibleFacilities(false);
				}}
			>
				<div className="bkd-dlg-facilities">
					<h2>امکانات عمومی</h2>
					<ul>
						{residence.publicFacilities.map((item, index) => (
							<li key={index}>
								<i className={PrimeIcons.CHECK}></i>
								{item.name}
							</li>
						))}
					</ul>
					<h2>امکانات اتاق ها</h2>
					<ul>
						{residence.roomFacilities.map((item, index) => (
							<li key={index}>
								<i className={PrimeIcons.CHECK}></i>
								{item.name}
							</li>
						))}
					</ul>
					<h2>امکاناتی که ارائه نمی شود</h2>
					<ol>
						{residence.notProvidedFacilities.map((item, index) => (
							<li key={index}>
								<i className={PrimeIcons.TIMES}></i>
								<span>{item.name}</span>
							</li>
						))}
					</ol>
				</div>
			</Dialog>

			{/* <div className="bkd-notes">
				<p dangerouslySetInnerHTML={{ __html: residence.notes }}></p>
				<a className="bkd-link-more" onClick={() => setIsVisibleNotes(true)}>
					مشاهده همه <i className={PrimeIcons.EXTERNAL_LINK}></i>
				</a>
			</div> */}

			<Dialog
				header={"جزییات کامل " + residence.name}
				visible={isVisibleNotes}
				style={{ width: "85vw" }}
				onHide={() => {
					if (!isVisibleNotes) return;
					setIsVisibleNotes(false);
				}}
			>
				<p dangerouslySetInnerHTML={{ __html: residence.notes }}></p>
			</Dialog>

			<div className="bkd-rooms">
				<h2>لیست اتاق های {residence.name}</h2>
				<div className="bkd-resevation">
					<div className="bkd-select">
						<label>شروع اقامت</label>
						<div>
							<DatePicker
								ref={datePickerRef}
								className="rmdp-mobile"
								weekDays={weekDays}
								numberOfMonths={1}
								minDate={new Date()}
								containerClassName="bkd-calendar"
								calendar={persian}
								locale={persian_fa}
								calendarPosition="bottom-right"
								onChange={(value) => confirmStartDate(value)}
								render={(value, openCalendar) => {
									return (
										<>
											<strong onClick={openCalendar}>
												{startDate?.toString()}
											</strong>
											<i
												className={PrimeIcons.ANGLE_DOWN}
												onClick={openCalendar}
											></i>
										</>
									);
								}}
							/>
						</div>
					</div>
					<span className="bkd-seperator"></span>
					<div className="bkd-select">
						<label>مدت اقامت</label>
						<div onClick={() => showDuration()}>
							{currentDuration > 0 && <strong>{currentDuration} شب</strong>}
							{currentDuration <= 0 && <strong>انتخاب کنید</strong>}
							<i className={PrimeIcons.ANGLE_DOWN}></i>
						</div>
					</div>
				</div>

				<Dialog
					visible={isVisibleDuration}
					headerStyle={{ padding: "3px" }}
					closable={false}
					resizable={false}
					style={{ width: "300px" }}
					onHide={() => {
						if (!isVisibleDuration) return;
						setIsVisibleDuration(false);
					}}
				>
					<ul className="bkd-select-duration">
						{durations.map((item, index) => (
							<li key={index} onClick={() => confirmDuration(item.total)}>
								<b>{item.total} شب</b>
								<span>({item.date})</span>
							</li>
						))}
					</ul>
				</Dialog>

				{/* <div className="bkd-filter">
					<label>فیلتر بر اساس : </label>
					<ul>
						<li>اتاق 1 نفره</li>
						<li>اتاق 2 نفره</li>
						<li>اتاق 3 نفره</li>
						<li>اتاق 4 نفره و بیشتر</li>
					</ul>
				</div> */}

				<ul className="bkd-rooms-list">
					{residence.roomTypes.map((item, index) => (
						<li key={index}>
							<div className="bkd-room-info">
								<h2>{item.name}</h2>
								<h3>
									<i className={PrimeIcons.USERS}></i>
									<span>ظرفیت اتاق : {item.totalCapacity} نفر</span>
								</h3>
								<h3>
									<i className={PrimeIcons.USERS}></i>
									<span>حداکثر نفرات اضافه : {item.totalExtraCapacity} نفر</span>
								</h3>
								<p>
									هزینه هر نفر اضافه :
									{item.extraPersonPrice.toLocaleString("en-US")} ریال
								</p>
							</div>
							<img src={item.imageUrl} />
							<div className="bkd-prices">
								<div>
									<span>{item.roomPrice.toLocaleString("en-US")}</span>
									<b>{item.offPercent}%</b>
								</div>
								<span>
									<strong>
										{(
											item.roomPrice -
											item.roomPrice * item.offPercent * 0.01
										).toLocaleString("en-US")}{" "}
										ریال
									</strong>
									/ 1 شب
								</span>
								{!startDate && (
									<a
										className="bkd-select-date"
										onClick={() => openDatePicker(item.residenceRoomTypeId)}
									>
										انتخاب تاریخ
									</a>
								)}
								{startDate && (
									<a
										className="bkd-change-date"
										onClick={() => openDatePicker(item.residenceRoomTypeId)}
									>
										تغییر تاریخ رزرو
									</a>
								)}
								{startDate && (
									<a
										className="bkd-confirm"
										onClick={() => confirm(item.residenceRoomTypeId)}
									>
										رزرو اتاق
									</a>
								)}
							</div>
							{item.total <= 0 && (
								<p className="bkd-alert">
									این اتاق در تاریخ انتخابی شما ظرفیت پذیرش ندارد، به منظور رزرو
									این اتاق در روز های دیگر لطفا تاریخ اقامت خود را تغییر دهید
								</p>
							)}
							{item.total > 0 && (
								<p className="bkd-success">
									تعداد {item.total} اتاق برای تاریخ انتخاب شده باقی مانده است
								</p>
							)}
						</li>
					))}
				</ul>
			</div>

			{/* <div className="bkd-laws">
				<h2>قوانین {residence.name}</h2>
				<ul>
					{residence.laws.map((item, index) => (
						<li key={index}>
							<img src={item.imageUrl} />
							<div>
								<h2>{item.name}</h2>
								<strong>{item.quickNote}</strong>
							</div>
							<p>{item.notes}</p>
						</li>
					))}
				</ul>
			</div> */}

			{/* <div className="bkd-places">
				<div className="bkd-header">
					<h2>فاصله تا مکان های مهم شهر</h2>
					<a className="bkd-link-more">مشاهده کامل نقشه</a>
				</div>
				<div className="bkd-body">
					<ul>
						{residence.places.map((item, index) => (
							<li key={index}>
								<a src={item.linkUrl} target="_blank">
									<div>{item.name}</div>
									<div>
										{item.duration < 60 && <b>{item.duration} دقیقه </b>}
										{item.duration >= 60 && (
											<b>{Math.round(item.duration / 60)} ساعت </b>
										)}
										<span>
											{item.vehicleType === "OnFoot" ? " پیاده " : " با خودرو "}
										</span>
									</div>
									<div>
										{item.distance < 1000 && <b>{item.distance} متر </b>}
										{item.distance >= 1000 && (
											<b>
												{Math.round((item.distance / 1000) * 100) / 100} کیلومتر
											</b>
										)}
										<span>مسافت</span>
									</div>
								</a>
							</li>
						))}
					</ul>
					<div className="map"></div>
				</div>
			</div> */}
		</article>
	);
}
